import React, { useState, useEffect } from 'react'
import SubHeader from '../general/SubHeader';

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  // const [error, setError] = useState('');  // For handling any error messages
  const [loading, setLoading] = useState(true);
  const [applyForm, setApplyForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null); // Store selected job details
  const [formData, setFormData] = useState({
    name: '',
    position: '',
    email: '',
    phone: '',
    education: '',
    experience: '',
    description: ''
  });

  const fetchJobs = async () => {
    try {
      const response = await fetch('https://apis.anvifoundation.com/anvi/get-job');
      // console.log(response);
      if (!response.ok) {
        throw new Error('Failed to fetch jobs');
      }
      const data = await response.json();
      setJobs(data.jobs);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch jobs on component mount
  useEffect(() => {
    fetchJobs();
  }, []);

  const handleApply = (job) => {
    setSelectedJob(job); // Set the selected job
    setApplyForm(true); // Show the application form
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submissionData = {
      ...formData,
      position: selectedJob.jobTitle, // Include the selected job title in the form submission
    };

    try {
      const response = await fetch('https://apis.anvifoundation.com/anvi/submit-career', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submissionData),
      });

      if (!response.ok) {
        throw new Error('Failed to submit application');
      }

      alert('Application submitted successfully!');
      setApplyForm(false); // Hide form after submission
      setFormData({
        name: '',
        position: '',
        email: '',
        phone: '',
        education: '',
        experience: '',
        description: '',
      }); // Reset form data
    } catch (error) {
      console.error(error);
      alert('Error submitting the application');
    }
  };

  return (
    <>
      <SubHeader message="Careers" />
      <section className='my-5'>
        <div className='container'>

          <div className='job-card-area'>
            <p className='sec-heading'>Jobs Openings</p>
            {/* <hr className='sec-heading-hr my-auto' /> */}

            {/* Loading indicator */}
            {loading ? (
              <p>Loading jobs...</p>
            ) : (
              jobs.map((job, index) => (
                <div key={index} className='job-card mt-4'>
                  <p className='sec-heading5'>Position: {job.jobTitle}</p>
                  <p className='text-muted'>Job Description<br />{job.description}</p>
                  <p className='text-muted'>Posted on: {new Date(job.datePosted).toLocaleDateString()}</p>
                  <button className='banner-btn' onClick={() => handleApply(job)}>Apply Now</button>
                </div>
              ))
            )}

          </div>
        </div>
      </section>

      {applyForm && (
        <section className='job-form'>
          <div className='container job-form-inner text-end'>

          <button className='close-btn' onClick={() => setApplyForm(false)}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div className='text-center'>
              <p className='sec-heading5'>Application Form</p>

              <form class="row g-3 px-lg-4 px-md-2 px-0 mt-3" onSubmit={handleSubmit}>
                <div class="col-md-6">
                  <input type="text" class="form-text" id="inputName" name='name' onChange={handleInputChange} value={formData.name} placeholder='Name' required />
                </div>

                <div class="col-md-6">
                  {/* <input type="tel" class="form-text" id="inputPositon" name='position' onChange={handleInputChange} value={selectedJob ? selectedJob.jobTitle : ''} placeholder={selectedJob.job} /> */}
                  <input type="text" className="form-text" id="inputPosition" name="position" onChange={handleInputChange} value={formData.position} placeholder={selectedJob.jobTitle} disabled required />
                </div>

                <div class="col-md-6">
                  <input type="email" class="form-text" id="inputEmail" name='email' onChange={handleInputChange} value={formData.email} placeholder='Email' required />
                </div>

                <div class="col-md-6">
                  <input type="tel" class="form-text" id="inputPhone" name='phone' onChange={handleInputChange} value={formData.phone} placeholder='Phone' required />
                </div>

                <div class="col-md-6">
                  {/* <input type="tel" class="form-text" id="inputEmail4" placeholder='Education' /> */}
                  <select className="form-text" name='education' onChange={handleInputChange} value={formData.education} required>
                    <option value="" disabled>Education</option>
                    <option value="Post Graduate">Post Graduate</option>
                    <option value="Graduate">Graduate</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="High School">High School</option>
                  </select>
                </div>

                <div class="col-md-6">
                  {/* <input type="tel" class="form-text" id="inputEmail4" placeholder='Education' /> */}
                  <select className="form-text" name='experience' onChange={handleInputChange} value={formData.experience} required>
                    <option value="" selected disabled>Experience</option>
                    <option value="More than 1 year">More than 1 year</option>
                    <option value="Less than 1 year">Less than 1 year</option>
                    <option value="Fresher">Fresher</option>
                  </select>
                </div>

                <div class="col-12">
                  <textarea type="text" class="form-text" name='description' onChange={handleInputChange} value={formData.description} placeholder='Describe Yourself..' style={{ height: '12em' }}></textarea>
                </div>
                <div class="col-12">
                  <button type="submit" class="donate-btn w-100">Submit</button>
                </div>
              </form>

            </div>
          </div>
        </section>
      )}

    </>
  )
}

export default Careers
